module.exports = __webpack_public_path__ + "img/fun-fact-thumb.53a7edf8.png";